export default __webpack_public_path__ + "static/media/banner-aicall.87d9ce2e.png";